var map = {
	"./back/card-back.png": 9146,
	"./card-back.png": 4064,
	"./crows/1.png": 1908,
	"./crows/10.png": 7951,
	"./crows/11.png": 5042,
	"./crows/12.png": 1285,
	"./crows/13.png": 5205,
	"./crows/2.png": 9739,
	"./crows/3.png": 6123,
	"./crows/4.png": 3414,
	"./crows/5.png": 1718,
	"./crows/6.png": 7530,
	"./crows/7.png": 7034,
	"./crows/8.png": 4963,
	"./crows/9.png": 7675,
	"./jokers/black.png": 4716,
	"./jokers/red.png": 7513,
	"./masks/1.png": 1312,
	"./masks/10.png": 793,
	"./masks/11.png": 8005,
	"./masks/12.png": 7358,
	"./masks/13.png": 8326,
	"./masks/2.png": 8966,
	"./masks/3.png": 5613,
	"./masks/4.png": 108,
	"./masks/5.png": 3606,
	"./masks/6.png": 6110,
	"./masks/7.png": 9638,
	"./masks/8.png": 9886,
	"./masks/9.png": 9705,
	"./rams/1.png": 91,
	"./rams/10.png": 4003,
	"./rams/11.png": 8689,
	"./rams/12.png": 9922,
	"./rams/13.png": 8709,
	"./rams/2.png": 2122,
	"./rams/3.png": 1602,
	"./rams/4.png": 440,
	"./rams/5.png": 7906,
	"./rams/6.png": 1113,
	"./rams/7.png": 90,
	"./rams/8.png": 9621,
	"./rams/9.png": 4337,
	"./tomes/1.png": 1114,
	"./tomes/10.png": 4660,
	"./tomes/11.png": 8527,
	"./tomes/12.png": 5069,
	"./tomes/13.png": 7001,
	"./tomes/2.png": 11,
	"./tomes/3.png": 1465,
	"./tomes/4.png": 3108,
	"./tomes/5.png": 1852,
	"./tomes/6.png": 3351,
	"./tomes/7.png": 7846,
	"./tomes/8.png": 5138,
	"./tomes/9.png": 4434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2321;